import React from 'react';
import styled from 'styled-components';

import ChevronIconAnimation from './ChevronIconAnimation';

interface Props {
  isActive: boolean;
}

const ChevronWrapper = ({ isActive }: Props) => (
  <Container>
    <IconWrapper active={isActive}>
      <ChevronIconAnimation />
    </IconWrapper>
  </Container>
);

export default ChevronWrapper;

const Container = styled.div`
  display: inline-flex;
  flex-grow: 1;
  justify-content: end;
`;

const IconWrapper = styled.div<{ active: boolean }>`
  display: flex;
  ${({ active }) => (active ? 'transform: rotate(180deg);' : null)}
  transition: transform 0.15s ease;
`;
